<template>
    <div>
        <b-row>
            <h2>Rotas</h2>
        </b-row>
        <b-row>
            <div class="col-md-12">
                <bar-rotas></bar-rotas>
            </div>
        </b-row>
        <b-row class="mt-3" align-v="end">
            <b-col>
                <label for="">Usuário</label>
                <b-form-select v-model="filtro.usuario" :options="listUsuarios"></b-form-select>
            </b-col>
            <b-col>
                <label>Filtrar por Situação</label>
                <b-form-select v-model="filtro.status" :options="listStatus"></b-form-select>
            </b-col>
            <b-col>
                <label>Data de Partida</label>
                <date-picker v-model="filtro.dataPartida" :config="datePickerConfig"></date-picker>
            </b-col>
            <b-col>
                <label>Data de Chegada</label>
                <date-picker v-model="filtro.dataChegada" :config="datePickerConfig"></date-picker>
            </b-col>
            <b-col>
                <b-button variant="primary" @click="getRotas()" title="Filtrar"><i class="fas fa-search"></i></b-button>
                <b-button variant="secondary" @click="limparFiltro()" title="Limpar Filtros"><i class="fa fa-history"></i></b-button>                
            </b-col>

        </b-row>
        <b-row>
            <b-table :items="rotas" :fields="fields" :busy="loading" hover striped small stacked="md" show-empty
                empty-text="Nenhuma rota encontrada ...">
                <template #cell(actions)="row">
                    <div class="custom-actions">
                        <div class="btn-group">
                            <a title="Relatório de Despesas" :href="'/adm/despesas/relatorio/' + row.item.id"
                                target="_blank" class="btn btn-outline-success">
                                <i class="fas fa-dollar-sign"></i>
                            </a>
                            <a title="Relatório de Visitas" :href="'/adm/rotas/diario/relatorio/' + row.item.id"
                                target="_blank" class="btn btn-primary">
                                <i class="far fa-calendar-check"></i>
                            </a>
                            <b-button variant="success" title="Aprovar Rota" @click="getAprova(row.item.id)"><i
                                    class="far fa-thumbs-up"></i></b-button>
                            <b-button variant="info" @click="edite(row.item.id)"><i class="fa fa-edit"></i></b-button>
                            <b-button variant="warning" @click="delRota(row.item.id)"><i
                                    class="far fa-trash-alt"></i></b-button>
                        </div>
                    </div>
                </template>
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando Rotas ...</strong>
                    </div>
                </template>
            </b-table>
        </b-row>
        <b-row>
            <b-pagination v-if="rows > 15" v-model="currentPage" :total-rows="rows" :per-page="perPage"
                @input="getRotas()"></b-pagination>
        </b-row>
        <!--------------------------- Aprovação de Rota ---------------------------->
        <b-modal v-model="modalAprova" :title="titleModalAprova" size="xl">
            <b-card>
                <b-card-body>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label> Situação </label>
                                <select v-model="status" class="form-control">
                                    <option value="APROVADO">APROVADO</option>
                                    <option value="PARCIAL">PARCIAL</option>
                                    <option value="BLOQUEADO">BLOQUEADO</option>
                                    <option value="FINALIZADO">FINALIZADO</option>
                                    <option value="EM ANALISE">EM ANALISE</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="list-group">
                                <div class="list-group-item">
                                    Total de Combustível: R$ {{ totalCombustivel }}
                                    <small class="text-danger">
                                        {{ totalLitros.toFixed(2) }} Litros
                                    </small>
                                </div>
                                <div class="list-group-item">
                                    Total Hospedagem : R$ {{ totalHospedagem }}
                                    <small class="text-danger">
                                        {{ parametros.hospedagem }} a diária
                                    </small>
                                </div>
                                <div class="list-group-item">
                                    Total Alimentação : R$ {{ totalAlimentacao }}
                                    <small class="text-danger">
                                        {{ parametros.alimentacao }} a diária
                                    </small>
                                </div>
                                <div class="list-group-item">
                                    Pedagio : R$ {{ totalPedagio.toFixed(2) }}
                                </div>
                                <div class="list-group-item active">
                                    Total : R$ {{ valorTOTAL }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>Rota</th>
                                    <th>Endereco</th>
                                    <th>Cidade</th>
                                    <th>Km Extra</th>
                                    <th>Qt. SubRotas</th>
                                    <th>Pedágio</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(rota, i) in listaRotas" :key="i">
                                    <td>{{ i + 1 }}</td>
                                    <td>{{ rota.endereco }}</td>
                                    <td>{{ rota.cidade }}</td>
                                    <td>{{ rota.km }}</td>
                                    <td>{{ rota.subrota }}</td>
                                    <td>{{ rota.pedagio }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr class="text-primary">
                                    <td>-</td>
                                    <td>Total Km {{ totalKM }}</td>
                                    <td></td>
                                    <td>{{ totalkm_extra }}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </b-card-body>
            </b-card>
            <template #modal-footer>
                <b-button size="sm" variant="primary" @click="aprovaRota" v-if="admin > 0">
                    Salvar
                </b-button>
                <b-button size="sm" variant="danger" @click="modalAprova = false">
                    Fechar
                </b-button>
            </template>
        </b-modal>
        <!-------------------------------------------------------------------- MODAL DE APROVACAO ---------------------------->
        <b-modal v-model="modalParametros" size="lg" title="Parâmetros de Calculo de rotas">
            <b-card>
                <b-card-body>
                    <div class="form-group">
                        <label>Km por Litro</label>
                        <input v-model="km_litro" type="text" v-mask="['##', '#']" class="form-control" />
                    </div>
                    <div class="form-group">
                        <label>Km por Dia </label>
                        <input v-model="km_dia" type="text" v-mask="['##', '###', '####']" class="form-control" />
                    </div>
                    <div class="form-group">
                        <label>Valor Médio de Hospedagem</label>
                        <input v-model="valor_hospedagem" type="text" v-mask="['#,##', '##,##', '###,##']"
                            class="form-control" />
                    </div>
                    <div class="form-group">
                        <label>Valor Médio de alimentação por dia</label>
                        <input v-model="valor_alimentacao" type="text" v-mask="['#,##', '##,##']" class="form-control" />
                    </div>
                    <div class="form-group">
                        <label>Valor médio do Combustível</label>
                        <input v-model="valor_combustivel" type="text" v-mask="['#,##', '##,##']" class="form-control" />
                    </div>
                    <div class="form-group">
                        <label>Km Extra</label>
                        <input v-model="km_extra" type="text" v-mask="['###']" class="form-control" />
                    </div>
                </b-card-body>
            </b-card>
            <template #modal-footer>
                <b-button size="sm" variant="primary" @click="saveParametro">
                    Salvar Parametros
                </b-button>
                <b-button size="sm" variant="danger" @click="modalParametros = false">
                    Fechar
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import {
    Vuetable
} from "vuetable-2";
import VueEvents from "vue-events";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import getBarRotas from "./table/Rotas";
import ActionsRotas from "./table/RotasActions";
import DatePicker from "vue-bootstrap-datetimepicker/src/component";
import moment from 'moment';


Vue.component("bar-rotas", getBarRotas);
Vue.component("action-rotas", ActionsRotas);

Vue.use(VueEvents);

export default {
    components: {
        DatePicker,
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
    },
    data() {
        return {
            filtro: {
                usuario: null,
                status: null,
                dataPartida: moment().subtract(1, 'months').format('DD/MM/YYYY'),
                dataChegada: moment().format('DD/MM/YYYY'),
            },
            datePickerConfig: {
                'format': 'DD/MM/YYYY',
                'showClose': false
            },
            currentPage: 1,
            rows: 0,
            perPage: 20,
            listaRotas: [],
            rotas: [],
            rota_id: 0,
            totalRotas: 0,
            admin: $("#Admin").val(),
            qtd_km: 0,
            justificativa: "",
            listRota: [],
            dtinicio: "",
            km_litro: 0,
            km_extra: 0,
            km_dia: 0,
            dtfim: "",
            status: "PARCIAL",
            totalCombustivel: 0,
            totalLitros: 0,
            totalHospedagem: 0,
            valor_hospedagem: 0,
            valor_alimentacao: 0,
            valor_combustivel: 0,
            totalAlimentacao: 0,
            totalKM: 0,
            valorTOTAL: 0,
            totalkm_extra: 0,
            parametros: {
                kmXdia: 0,
                kmXlitro: 0,
                kmExtra: 0,
                alimentacao: 0,
                hospedagem: 0,
                combustivel: 0,
            },
            listUsuarios: [],
            totalPedagio: 0,
            listStatus: [
                {
                    text: "Todos",
                    value: null
                },
                {
                    text: "Parcial",
                    value: "PARCIAL",
                },
                {
                    text: "Bloqueado",
                    value: "BLOQUEADO",
                },
                {
                    text: "Iniciado",
                    value: "INICIADO",
                },
                {
                    text: "Aprovado",
                    value: "APROVADO",
                },
                {
                    text: "Em análise",
                    value: "EM ANALISE",
                },
            ],
            sortOrder: [{
                field: "name",
                sortField: "name",
                direction: "asc"
            }],
            moreParams: {},
            data_partida: "",
            data_chegada: "",
            modalAprova: false,
            titleModalAprova: "",
            modalParametros: false,
            loading: false,
            fields: [
                { key: 'actions', label: '' },
                { key: 'usuario.name', label: 'Usuário' },
                { key: 'status', label: 'Situação' },
                { key: 'total_km', label: 'Total KM' },
                { key: 'data_inicio', label: 'Data Partida', formatter: (value) => { return moment(value).format("DD/MM/YYYY") } },
                { key: 'data_fim', label: 'Data Chegada', formatter: (value) => { return moment(value).format("DD/MM/YYYY") } },
                { key: 'created_at', label: 'Adicionada Em', formatter: (value) => { return moment(value).format("DD/MM/YYYY") } },
            ]
        };
    },
    methods: {
        limparFiltro() {
            this.filtro = {
                usuario: null,
                status: null,
                dataPartida: moment().subtract(1, 'months').format('DD/MM/YYYY'),
                dataChegada: moment().format('DD/MM/YYYY'),
            }
        },
        delRota(id) {
            var vm = this;
            vm.$swal({
                title: 'Deletar Rota.',
                text: 'Você deseja deletar esta rota agora? esta ação não poderá ser revertida.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim, deletar.',
                cancelButtonText: 'Não!',
                showCloseButton: true
            }).then((result) => {
                if (result.value) {
                    axios.post('/adm/rotas/destroy', { id: id }).then((response) => {
                        let obj = response.data;
                        if (obj.success) {
                            vm.$swal('Ok', obj.success, 'success');
                            vm.getRotas();
                            vm.$events.fire('get-load');
                        }
                    }).catch((error) => {
                        console.log(error.response);
                    });
                }
            })
        },
        edite(id) {
            window.location.href = '/adm/rotas/edit/' + id;
        },
        getRotas() {
            const vm = this;
            vm.loading = true;
            let data = {
                currentPage: vm.currentPage,
                status: vm.filtro.status,
                dataPartida: vm.filtro.dataPartida,
                dataChegada: vm.filtro.dataChegada,
                usuario: vm.filtro.usuario
            }
            axios.get('/adm/rotas/list', { params: data })
                .then((response) => {
                    // console.log(response);
                    vm.rotas = response.data.data;
                    vm.rows = response.data.total;
                }).catch((erro) => {
                    console.log(erro);
                }).finally(() => {
                    vm.loading = false;
                })
        },
        onFilterData() {
            if (this.data_partida === "" && this.data_chegada === "") {
                return alert("Atenção, informe uma data de partida e/ou data de chegada");
            }
            if (this.data_partida) {
                this.moreParams.partida = this.data_partida;
            }
            if (this.data_chegada) {
                this.moreParams.chegada = this.data_chegada;
            }
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        onFilterUser(e) {
            var user = e.target.value;
            console.log(e);
            this.moreParams.usuario = user;
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        getModalParametros() {
            this.km_litro = this.parametros.kmXlitro;
            this.km_extra = this.parametros.kmExtra;
            this.valor_combustivel = this.parametros.combustivel;
            this.valor_hospedagem = this.parametros.hospedagem;
            this.valor_alimentacao = this.parametros.alimentacao;
            this.km_dia = this.parametros.kmXdia;

            this.modalParametros = true;
        },
        saveParametro() {
            var vm = this;
            var data = {
                edita: this.parametro_id,
                km_litro: this.km_litro,
                km_dia: this.km_dia,
                km_extra: this.km_extra,
                valor_hospedagem: this.valor_hospedagem.replace(",", "."),
                valor_alimentacao: this.valor_alimentacao.replace(",", "."),
                valor_combustivel: this.valor_combustivel.replace(",", "."),
            };
            axios
                .post("/adm/parametros/rotas/save", data)
                .then(function (response) {
                    let obj = response.data;
                    vm.$swal("success", obj.success, "success");
                    vm.parametro_id = obj.id;
                    vm.modalParametros = false;
                    console.log(obj);
                })
                .catch(function (error) {
                    console.log(error.response);
                });
        },
        aprovaRota() {
            $(".loading").show();
            var vm = this;
            var data = {
                id: vm.rota_id,
                combustivel: vm.totalCombustivel,
                hospedagem: vm.totalHospedagem,
                alimentacao: vm.totalAlimentacao,
                distance: vm.totalKM,
                valor_total: vm.valorTOTAL,
                status: vm.status,
            };
            axios
                .post("/adm/rotas/aprova", data)
                .then(function (response) {
                    let obj = response.data;
                    console.log(obj);
                    vm.status = "";
                    if (obj.success) {
                        vm.$swal("Ok", "Rota Atualizada com sucesso", "success");
                        vm.rota_id = 0;
                    }
                    vm.getLoad();
                    vm.modalAprova = false;
                    $(".loading").hide();
                })
                .catch(function (error) {
                    var erro = error.response.data;
                    vm.$swal("OPS", erro.errors, "error");
                    $(".loading").hide();
                });
        },

        getAprova(id) {
            var vm = this;
            var ById = {
                id: id,
            };
            $(".loading").show();
            this.listaRotas = [];
            this.rota_id = id;
            var kmextra = 0;
            var total_extra = 0;
            axios
                .get("/adm/rotas/list", {
                    params: ById
                })
                .then(function (response) {
                    let obj = response.data;
                    var data = [];

                    obj.roteiro.forEach(function (x, z) {
                        vm.totalPedagio += x.valor_pedagio ?
                            parseFloat(x.valor_pedagio) :
                            0;
                        vm.getAddLatLong(
                            x.latitude,
                            x.longitude,
                            x.total_kmextra,
                            x.subrota,
                            x.valor_pedagio
                        );
                        kmextra += x.total_kmextra ? parseFloat(x.total_kmextra) : 0;
                    });
                    total_extra = parseFloat(vm.parametros.kmXlitro / kmextra);
                    vm.totalLitros =
                        parseFloat(obj.total_km + kmextra) / vm.parametros.kmXlitro;
                    vm.totalCombustivel = parseFloat(obj.valor_combustivel).toFixed(2);
                    vm.totalHospedagem = parseFloat(obj.valor_hospedagem).toFixed(2);
                    vm.totalAlimentacao = parseFloat(obj.valor_alimentacao).toFixed(2);
                    vm.totalKM = parseFloat(obj.total_km + kmextra).toFixed(2);
                    vm.valorTOTAL = parseFloat(obj.valor_total + total_extra).toFixed(2);
                    vm.totalkm_extra = kmextra;
                    vm.status = obj.status;

                    vm.titleModalAprova = "Aprovação de Rota de " + obj.usuario.name;
                    vm.modalAprova = true;
                    $(".loading").hide();
                })
                .catch(function (error) {
                    console.log(error);
                    $(".loading").hide();
                });
        },
        getAddLatLong(lat, lng, kmextra, subrota, pedagio) {
            var vm = this;
            var data = {
                latitude: lat,
                longitude: lng
            };

            axios
                .get("/adm/rotas/latlng", {
                    params: data,
                })
                .then(function (response) {
                    let obj = response.data;
                    vm.listaRotas.push({
                        endereco: obj.endereco,
                        cidade: obj.cidade,
                        coordenadas: obj.coordenadas,
                        km: kmextra ? parseFloat(kmextra) : 0,
                        subrota: subrota ? subrota.length : 0,
                        pedagio: pedagio ? parseFloat(pedagio) : 0,
                    });
                })
                .catch(function (error) {
                    console.log(error.response);
                });
        },
        onPaginationData(paginationData) {
            var vm = this;
            var obj = paginationData.data;
            //console.log(obj)
            vm.totalDespesa = 0;
            vm.listUsuarios = [];
            var arrayUsuario = [];
            obj.forEach(function (m, n) {
                vm.totalDespesa += parseFloat(m.valor);
                var idx = arrayUsuario.indexOf(m.usuario.name);
                if (idx === -1) {
                    arrayUsuario.push(m.usuario.name.trim());
                }
            });
            vm.listUsuarios = arrayUsuario;
            this.$refs.pagination.setPaginationData(paginationData);
            this.$refs.paginationInfo.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        onFilterStatus(key) {
            //var status = e.target.value;
            var status = key ? key.value : "PARCIAL";
            this.moreParams.status = status;
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        getParametros: function () {
            var vm = this;
            axios
                .get("/adm/parametros/rotas/list")
                .then(function (response) {
                    let obj = response.data;
                    vm.parametros = {
                        kmXdia: obj.km_dia,
                        kmXlitro: obj.km_litro,
                        kmExtra: obj.km_extra,
                        alimentacao: parseFloat(obj.valor_alimentacao).toFixed(2),
                        hospedagem: parseFloat(obj.valor_hospedagem).toFixed(2),
                        combustivel: parseFloat(obj.valor_combustivel).toFixed(2),
                    };
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getArray: function () {
            (this.admin = parseInt($("#Admin").val())),
                console.log("admin ===" + this.admin);
            if (this.admin > 0) {
                return [{
                    name: "__component:action-rotas",
                    title: '<i class="fa fa-chevron-down"></i> Ações',
                    titleClass: "text-center",
                    dataClass: "text-center",
                },

                {
                    name: "usuario.name",
                    title: "Usuário",
                    sortField: "usuario",
                },
                {
                    name: "status",
                    title: "Situação",
                    sortField: "status",
                },
                {
                    name: "total_km",
                    title: "Total KM",
                    sortField: "totalkm",
                },
                {
                    name: "data_inicio",
                    title: "Data Partida ",
                    callback: "formatDate|DD/MM/YYYY",
                },
                {
                    name: "data_fim",
                    title: "Data Chegada ",
                    callback: "formatDate|DD/MM/YYYY",
                },
                ];
            } else {
                return [{
                    name: "__component:action-rotas",
                    title: '<i class="fa fa-chevron-down"></i> Ações',
                    titleClass: "text-center",
                    dataClass: "text-center",
                },

                {
                    name: "status",
                    title: "Situação",
                    sortField: "status",
                },
                {
                    name: "total_km",
                    title: "Total KM",
                    sortField: "totalkm",
                },
                {
                    name: "data_inicio",
                    title: "Data Partida ",
                    callback: "formatDate|DD/MM/YYYY",
                },
                {
                    name: "data_fim",
                    title: "Data Chegada ",
                    callback: "formatDate|DD/MM/YYYY",
                },
                ];
            }
        },
        formatDate: function (date) {
            return moment(date).format("DD/MM/Y");
        },

        filtrar: function (data) {
            this.moreParams = {
                usuario: data,
            };
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        onFilterReset: function () {
            this.moreParams = {};
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },

        getLoad: function () {
            this.$refs.vuetable.refresh();
        },
        loadUsers() {
            const vm = this;
            axios.get('/user/perfil/gestor').then((response) => {
                vm.listUsuarios = [];
                vm.listUsuarios = response.data.map((el) => {
                    return { value: el.id, text: el.name };
                })
                vm.listUsuarios.push({ value: null, text: 'Todos' })
                //console.log(vm.listUsuarios)
            }).catch((erro) => {
                console.log(erro);
            })
        }
    },

    mounted() {
        this.getParametros();
        this.getRotas();
        this.loadUsers();
        this.$events.$on("get-aprova", (e) => this.getAprova(e));
         this.$events.$on("get-load", (e) => this.getLoad());
         this.$events.$on("filter-reset", (e) => this.onFilterReset());
         this.$events.$on("filter-set", (e) => this.filtrar(e));
         this.$events.$on("get-parametros", (e) => this.getModalParametros()); 
    },
};
</script>

<style></style>



// WEBPACK FOOTER //
// resources/assets/js/components/rotas/ListRotas.vue